import {TreeService} from '@/service'
import {Category} from '@/libs'

export async function AutoCreateResDir() {
  console.log('开始默认目录的创建')
  try {
    // 一级目录
    await TreeService.insert(Category.ResourceFavoriteDir, '0', '我的标准资源', '');
    await delay();
    await TreeService.insert(Category.ResourceFavoriteDir, '0', '我的设计资料', '');
    await delay();
    await TreeService.insert(Category.ResourceFavoriteDir, '0', '我的技术手册', '');
    await delay();
    await TreeService.insert(Category.ResourceFavoriteDir, '0', '我的视频资源', '');
  } catch (error) {}
}

export function delay(time = 1000) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true)
    }, time)
  })
}
